module.exports = __webpack_public_path__ + "img/huoban1.0788de59.png";